import React, { CSSProperties, PropsWithChildren } from "react";
import Button, { ButtonProps } from "@common/components/Button";
import { Link, LinkProps } from "react-router-dom";
import { Box, SxProps, Theme, Tooltip } from "@mui/material";
import LinkWithQuery from "@pages/Assets/common/CountIndicator/LinkWithQuery";

type AssetsLinkProps = LinkProps & {
  keepQuery?: boolean;
  disabled?: boolean;
  tooltip?: string;
  buttonProps?: ButtonProps;
  sxProps?: SxProps<Theme>;
  maxWidth?: string;
};

const AssetsLink = ({
  keepQuery = false,
  to,
  state,
  disabled,
  tooltip,
  buttonProps,
  sxProps,
  children,
  maxWidth,
  ...other
}: PropsWithChildren<AssetsLinkProps>) => {
  const WrappedButton = () => {
    const btnProps: ButtonProps = {
      variant: "outlined",
      ignoreLocalization: true,
      ...buttonProps,
    };
    const mergedSxProps: SxProps<Theme> = {
      position: "relative",
      width: "100%",
      maxWidth: "100%",
      "& .MuiTypography-root": {
        position: "absolute",
        top: "50%",
        left: "0",
        right: "0",
        transform: "translateY(-50%)",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        padding: "0 10px",
      },

      ...sxProps,
    };

    return (
      <Tooltip title={tooltip ?? ""} arrow disableInteractive>
        <span
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <Button disabled={disabled} sx={mergedSxProps} {...btnProps}>
            {Boolean(children) ? children : "-"}
          </Button>
        </span>
      </Tooltip>
    );
  };

  const containerStyle: CSSProperties = {
    display: "flex",
    flex: "1",
  };

  if (disabled) {
    return (
      <Box style={containerStyle}>
        <WrappedButton />
      </Box>
    );
  }

  const LinkComponent = keepQuery ? LinkWithQuery : Link;
  const linkComponentProps = keepQuery
    ? { keepSort: false, keepQuery }
    : undefined;

  return (
    <LinkComponent
      {...linkComponentProps}
      to={to}
      state={state}
      style={
        other.style || {
          ...containerStyle,
          textDecoration: "none",
        }
      }
    >
      <WrappedButton />
    </LinkComponent>
  );
};

export default AssetsLink;
